import { useEffect, useState } from "react";
import { systemService, SystemSettings } from "../../services/systemService";
import useToken from "../../../../hooks/auth/useToken";

export default function useSystemSettings() {
  const [settings, setSettings] = useState<SystemSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const { token } = useToken();

  const getSystemInfo = async () => {
    if (!token) {
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const settingsData = await systemService.getSystemInfo(token);
      setSettings(settingsData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setError(error);
      setLoading(false);
    }
  };

  const updateAppVersion = async (version: string) => {
    if (!token) return;

    try {
      await systemService.changeAppVersion(version, token);
      await getSystemInfo();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const updateChargePercent = async (percent: string) => {
    if (!token) return;

    try {
      await systemService.changeChargePercent(percent, token);
      await getSystemInfo();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const updateLocalOperatorNetworkError = async (status: string) => {
    if (!token) return;

    try {
      await systemService.changeLocalOperatorNetworkError(status, token);
      await getSystemInfo();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const updatePromoShareTemplate = async (template: string) => {
    if (!token) return;

    try {
      await systemService.changePromoShareTemplate(template, token);
      await getSystemInfo();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const updateAppDownloadUrl = async (url: string) => {
    if (!token) return;

    try {
      await systemService.changeAppDownloadUrl(url, token);
      await getSystemInfo();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  const updateWithdrawalNotificationEmail = async (email: string | null) => {
    if (!token) return;

    try {
      await systemService.changeWithdrawalNotificationEmail(email, token);
      await getSystemInfo();
    } catch (error) {
      console.error(error);
      setError(error);
      throw error;
    }
  };

  useEffect(() => {
    getSystemInfo();
  }, [token]);

  return {
    settings,
    loading,
    error,
    getSystemInfo,
    updateAppVersion,
    updateChargePercent,
    updateLocalOperatorNetworkError,
    updatePromoShareTemplate,
    updateAppDownloadUrl,
    updateWithdrawalNotificationEmail,
  };
}
